import configHandler from '../../configHandler'
import FirstName from './FirstName'
import LastName from './LastName'

const ERROR_INVALID_FULL_NAME = 'invalidFullName'

const parse = (fullname) => {

    return {
        input: fullname,
        splitNames: fullname.trim().split(' ').filter(el => el.trim().length > 1),
        isRequired: false,

        required: function () {
            this.isRequired = true
            return this
        },

        firstName: function () {
            if (!this.splitNames.length) {
                return ''
            }
            return this.splitNames.slice(0, Math.max(1 , this.splitNames.length - 1)).join(' ')
        },

        lastName: function () {
            if (!this.splitNames.length) {
                return ''
            }
            if (this.splitNames.length === 1) {
                return ''
            }
            return this.splitNames[this.splitNames.length-1]
        },

        isValid: function () {
            return this.validate().length === 0
        },

        validate: function () {
            const errors = []
            if (!this.splitNames.length) {
                if (this.isRequired) {
                    errors.push(configHandler.errorMessages().text[ERROR_INVALID_FULL_NAME])
                }

                return errors
            }
            if (this.splitNames.length < 2) {
                errors.push(configHandler.errorMessages().text[ERROR_INVALID_FULL_NAME])
                return errors
            }
            return errors.concat(FirstName.parse(this.firstName()).validate(), LastName.parse(this.lastName()).validate())
        },

        value: function () {
            return String(this.input)
        },

        format: function () {
            return String(this.parsed())
        },
    }
}

export default {
    parse,
}